@if (formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="justify-all">
      <img class="safety-logo" src="../../../assets/images/safety_2_logo_white.svg"/>
      <mat-card appearance="outlined" class="login-card">
        <img class="topLeft-inCard" src="../../../assets/images/SAFETY-CORNER.svg"/>
        <mat-card-header class="no-text-margin center-header" style="margin: 0 auto">
          <h2>{{ 'safety²-EHS Software' }}</h2>
        </mat-card-header>
        <mat-card-subtitle style="text-align: center">
          <h3>{{ 'enterSecurityCode' | translate }}</h3>
        </mat-card-subtitle>
        <mat-card-content>
          <div fxLayoutGap="8px" class="full-width" style="display: flex; justify-content: center">
            @for (item of fields; track item) {
              <mat-form-field style="width: 50px; text-align: center" appearance="outline">
                <input #otpInput type="text" matInput pattern="[0-9]*" style="font-size: 20px"
                  [formControlName]="'field' + item"
                  inputmode="numeric"
                  (keydown)="onKeyDown($event, item)"
                  (input)="onInput($event, item)"
                  maxlength="1">
              </mat-form-field>
            }
          </div>
          <div fxLayoutAlign="center">
            <button class="half-width button-color" fxFlex="0 0 calc(50% - 4px)" mat-raised-button
            type="submit" color="primary">{{ 'login' | translate }}</button>
          </div>
        </mat-card-content>
        <img class="bottomRight-inCard" src="../../../assets/images/SAFETY-CORNER.svg"/>
      </mat-card>
      <div class="company-logo"></div>
    </div>
  </form>
}
